import StoreUtil from '@/store/StoreUtil'

export default {
  OPPORTUNITIES: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.tracker,
    'opportunities'
  ),
  ERROR: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.tracker, 'error'),
}
